class SearchResults extends HTMLElement {
  constructor() {
    super();
    this.types = this.getAttribute('data-types').split(',');

    this.url = new URL(window.location.href);
    this.url.searchParams.set('type', this.types.join(','));
    this.url.searchParams.set('view', 'partial');
    this.url.searchParams.delete('page');
  }

  async connectedCallback() {
    const response = await fetch(this.url);
    const html = await response.text();
    this.innerHTML = html;
    // const searchGridRows = this.querySelectorAll('.search-grid__row');
    // const first14Rows = Array.from(searchGridRows).slice(0, 14);
    // const remainingRows = Array.from(searchGridRows).slice(14);
    // first14Rows.forEach(row => {
    //   row.classList.add('search-grid__row--visible');
    // });
    // remainingRows.forEach(row => {
    //   row.classList.add('search-grid__row--hidden');
    // });
  }
}

customElements.define('search-results', SearchResults);